"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class ErrorCodes {
  static PhotodiodeUtils = {
    calculatePeakLightIntensity: {
      peakPhotodiodeNotInRange: 'peak_light_error'
    },
    calculatePeakPhotodiode: {
      computedPeakPhotodiodeNotInRange: 'peak_photodiode_error'
    }
  };
  static OneStage = {
    oneStageRf: {
      rfTooHigh: 'rf_too_high'
    }
  };
  static TwoStage = {
    pickOpAmp_2ndStage: {
      noOpAmpAvailable: 'no_op_amps_available_for_second_stage'
    }
  };
  static fixedOpAmpNoGood = 'fixed_op_amp_no_good';
  static noOpAmpAvailableForSingleStageTooSlow = 'no_op_amps_available_for_single_stage_too_slow';
  static noOpAmpAvailableForSingleStageTooFast = "no_op_amps_available_for_single_stage_too_fast";
  static noOpAmpAvailableForFirstStageTooSlow = "no_op_amps_available_for_first_stage_too_slow";
  static noOpAmpAvailableForFirstStageTooFast = "no_op_amps_available_for_first_stage_too_fast";
  static internalCfTooHigh = 'internal_cf_too_high';
}
exports.default = ErrorCodes;